import React, { useState, useMemo } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import { Button, Input } from 'antd'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import * as api from '../api/pgads'

const title = 'Profit/Cost'

const ProfitCost = ({ utilityNameMap, unitNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const headerWithFormatter = useMemo(
    _ =>
      ProfitCostHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Utility / Unit :
      </div>
      <UtilityUnitSelection
        style={{ width: '400px' }}
        utility={insertData.utility}
        unit={insertData.unitId}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            utility: value[0],
            unitId: value[1],
            unit: value[1].substr(3),
          })
        }}
      />
      <div
        style={{
          marginLeft: '50px',
          width: '70px',
          display: 'grid',
          alignContent: 'center',
        }}
      >
        Profit :
      </div>
      <Input
        style={{ width: '200px' }}
        value={insertData.profit}
        onChange={e => setInsertData({ ...insertData, profit: e.target.value })}
        maxLength={64}
      />
      <div
        style={{
          marginLeft: '50px',
          width: '70px',
          display: 'grid',
          alignContent: 'center',
        }}
      >
        Cost :{' '}
      </div>
      <Input
        style={{ width: '200px' }}
        value={insertData.cost}
        onChange={e => setInsertData({ ...insertData, cost: e.target.value })}
        maxLength={64}
      />
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={headerWithFormatter}
      saveTask={api.saveProfitCost}
      retrieveTask={api.getProfitCost}
      deleteTask={api.deleteProfitCost}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={ProfitCostHeaders}
      widthOffset={50}
      heightOffset={270}
      // totalWidth={1200}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={30}
    />
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(ProfitCost)

export const ProfitCostHeaders = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'profit',
    display: 'Profit',
    width: 450,
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({
    ident: 'cost',
    display: 'Cost',
    width: 450,
    alignment: 'left',
    ellipsis: true,
  }),
]
